import type { FunctionComponent, SVGProps } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';

import type { LayerSectionIconProps } from './LayerSectionIcon.types';

export type LayerSectionIconComponent =
  FunctionComponent<LayerSectionIconProps>;

const iconContainerSx = (
  width: number,
  height: number,
  color: string | undefined,
): SxProps<Theme> => ({
  width,
  height,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: color ?? 'currentColor',
});

/** Wraps an SVGR icon so fills/strokes using `currentColor` follow the `color` prop. */
export const createSvgLayerSectionIcon = (
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>,
): LayerSectionIconComponent => {
  const LayerSectionIcon = ({
    width = 32,
    height = 32,
    color,
    className,
    'data-testid': dataTestId,
  }: LayerSectionIconProps): JSX.Element => (
    <Box
      aria-hidden
      className={className}
      data-testid={dataTestId}
      sx={iconContainerSx(width, height, color)}
    >
      <Icon width={width} height={height} />
    </Box>
  );

  LayerSectionIcon.displayName = `LayerSectionIcon(${Icon.displayName ?? 'Svg'})`;

  return LayerSectionIcon;
};
